/*
 * Copyright (C) 2018 Spanning Cloud Apps. LLC  All rights reserved.
 */
import { ValidationUtils } from 'spanalog/lib/utils/ValidationUtils';
import './paging.tpl.html';

(function () {
  /**
   * This directive displays paging controls.
   */
  angular
    .module('shared.paging', ['sbsf.constants', 'services.util'])
    .directive('sbsfPaging', directive)
    .controller('PagingCtrl', controller);

  /**
   * Defines the sbsf-paging directive.
   *
   * @returns {Object} - The directive settings
   */
  function directive() {
    return {
      controller: 'PagingCtrl',
      templateUrl: 'shared/paging/paging.tpl.html',
      restrict: 'E',
      scope: {
        // The total number of pages
        pageCount: '=',
        // The current page
        pageNum: '=',
        // The number of items per page
        pageSize: '=',
        // The total number of items across all pages
        itemCount: '=',
        // The client side pagination
        clientSide: '='
      }
    };
  }

  controller.$inject = ['$rootScope', '$scope', '$timeout', 'BULK_RESTORE_EVENTS'];

  /**
   * The controller for the directive.
   */
  function controller($rootScope, $scope, $timeout, BULK_RESTORE_EVENTS) {
    ValidationUtils.assertAtLeast($scope.pageCount, 1, 'page-count');
    ValidationUtils.assertAtLeast($scope.pageNum, 1, 'page-num');
    ValidationUtils.assertAtLeast($scope.pageSize, 1, 'page-size');
    ValidationUtils.assertAtLeast($scope.itemCount, 0, 'item-count');
    ValidationUtils.assertAtMost($scope.pageNum, $scope.pageCount, 'page-num');

    // When the page number changes we will start a timer to automatically go to that page after a delay. This gives
    // the user a little time to type more before we make the switch.
    var setPageTimer;

    // Store a local copy of the value so we can check for changes and form entry errors before updating the original.
    $scope.inputPageNum = $scope.pageNum;

    $scope.goToPage = goToPage;
    $scope.pageNumChanged = pageNumChanged;
    $scope.setPage = setPage;

    // Watch for external changes to the page number and update our input page number. This is to keep multiple paging
    // controllers in sync.
    $scope.$watch(
      function () {
        return $scope.pageNum;
      },
      function (newValue, oldValue) {
        if (newValue !== oldValue) {
          $scope.inputPageNum = newValue;
        }
      }
    );

    /**
     * Sets the current page number from the pagination controls. This one does not require validation.
     *
     * @param {number} pageNum - the new current page number.
     */
    function goToPage(pageNum) {
      $scope.pageNum = pageNum;
      $rootScope.$emit(BULK_RESTORE_EVENTS.PAGING_EVENT, pageNum, { clientSide: $scope.clientSide });
    }

    /**
     * Sets the current page number from the page number input field. This one requires validation.
     *
     * @param {object} form - the form containing the controls.
     * @param {number} pageNum - the new current page number.
     */
    function setPage(form, pageNum) {
      if (form.$valid && pageNum !== $scope.pageNum) {
        // Stop any existing timer
        cancelSetPageTimer();

        $scope.pageNum = pageNum;
        $rootScope.$emit(BULK_RESTORE_EVENTS.PAGING_EVENT, pageNum, { clientSide: $scope.clientSide });
      }
    }

    /**
     * Called when the value in the page number input field changes. We want to watch for the value changing with one
     * of the up/down arrow buttons and set the page after a delay.
     *
     * @param {object} form - the form containing the controls.
     * @param {number} pageNum - the new current page number.
     */
    function pageNumChanged(form, pageNum) {
      // Stop any existing timer
      cancelSetPageTimer();

      // If the new number is valid and different start a timer to set the page
      if (form.$valid && pageNum !== $scope.pageNum) {
        setPageTimer = $timeout(function () {
          $scope.setPage(form, pageNum);
        }, 500); // delay 500 ms
      }
    }

    /**
     * Cancels any timer that might be set for changing the page.
     */
    function cancelSetPageTimer() {
      if (setPageTimer) {
        $timeout.cancel(setPageTimer);
        setPageTimer = null;
      }
    }
  }
})();
